import bridge from './bridge';

export class OfflineUnsupportedError extends Error {
  constructor(endpoint) {
    super(`Endpoint not supported offline: ${endpoint}`);
    this.code = 'OFFLINE_UNSUPPORTED';
  }
}

export async function apiRequestThroughBridge({ method, endpoint, body, attachments, if_match }) {
  return bridge.call('api.request', { method, endpoint, body, attachments, if_match });
}
